import { Link, Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ForbiddenImageSrc from './forbidden.png'
import config from 'config'

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: ' #eef0f4',
        textAlign: 'center',
        '& img': {
            marginTop: '6vw',
            margin: 'auto',
            maxWidth: '50%',
        },
    },
    content: {
        [theme.breakpoints.up('md')]: {
            marginTop: '-15%',
        },
        margin: 'auto',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        flexWrap: 'wrap',
        textAlign: 'center',
        background: 'transparent',
        left: 0,
        right: 0,
    },
    footer: {
        maxWidth: 625,
        marginTop: '-45px',
        margin: 'auto',
        left: 0,
        right: 0,
        marginBottom: '70px',
    },
    container: {
        marginTop: '-65px',
        [theme.breakpoints.down('xl')]: {},
    },
    forbiddenText: {
        color: ' #3f3767',
        fontWeight: '300',
        fontSize: '14vw',
    },
    text: {
        fontSize: '30px',
        [theme.breakpoints.down('lg')]: {
            fontSize: '22px',
            paddingLeft: '20px',
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '2.25vw',
            paddingLeft: '32px',
        },
    },
}))

const ForbiddenPage = (props) => {
    const { description, linkText, errorCode, showLink = true } = props

    const classes = useStyles()

    return (
        <>
            <div className={classes.root}>
                <img
                    src={`${config.APP_SUBPATH}${ForbiddenImageSrc}`}
                    alt="Forbidden Page"
                />

                <Box className={classes.content}>
                    <Box className={classes.container}>
                        <Typography className={classes.forbiddenText}>
                            {errorCode}
                        </Typography>
                    </Box>
                </Box>
                <Box className={classes.footer}>
                    <Box
                    // marginTop="6vh"
                    >
                        <Box>
                            <Typography style={{ fontSize: '22px' }}>
                                {description}
                                {showLink && (
                                    <Link
                                        component="a"
                                        underline="none"
                                        href={`${config.APP_SUBPATH}/`}
                                        style={{
                                            color: '#453fbb',
                                            fontSize: '22px',
                                            fontWeight: 300,
                                            marginLeft: '8px',
                                        }}
                                    >
                                        {linkText}
                                    </Link>
                                )}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </div>
        </>
    )
}

export default ForbiddenPage
